/** 이벤트(미션/빙고/진행현황) 페이지 공통 최소 너비 */
export const EVENT_PAGE_MIN_WIDTH = 1080;
